import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { PropertyTypeEnum } from '@app/enums/property-type.enum';

export class FillingScore1000 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage._households.length &&
            mortgage._households.every((h) => h.members.every((m) => m.type && m.age >= 0)) &&
            (!mortgage.purposes.includes('refinancing') ||
                !mortgage.outOfFixationDrawing ||
                mortgage.refinancingDate) &&
            (!mortgage.hasSpecificProperty ||
                (mortgage.hasSpecificProperty &&
                    mortgage._properties.every((p) => {
                        if (!p.type) {
                            return false;
                        }
                        if (!p.value) {
                            return false;
                        }
                        const propType: PropertyTypeEnum = PropertyTypeEnum[p.type];
                        if (
                            [
                                PropertyTypeEnum.flatPrivate,
                                PropertyTypeEnum.flatCooperative,
                                PropertyTypeEnum.familyHouse,
                                PropertyTypeEnum.recreationalObject,
                                PropertyTypeEnum.apartmentBuilding,
                            ].includes(propType)
                        ) {
                            if (p.isDeveloperProject === undefined) {
                                return false;
                            }
                            if (p.isDeveloperProject && !p.developerProject) {
                                return false;
                            }
                        }
                        if ([PropertyTypeEnum.apartmentBuilding].includes(p.type)) {
                            if (p.cadastreRegisterSeparately === undefined) {
                                return false;
                            }
                            if (p.commercialAreaPercentage === undefined) {
                                return false;
                            }
                            if (!p.housingUnitsCount) {
                                return false;
                            }
                        }
                        return true;
                    })))
        );
    }
}
